// Rules hardcoded in the LotoTon_MultiLevelLottery smart contract (contracts/LotoTon_MultiLevelLottery.fc).
// Prices, thresholds and other owner-configurable values are read from the contract at runtime instead.

/** Tickets in one cycle of every game level. */
export const CYCLE_TICKETS = 777;

/** Prizes of one cycle; the multiplier is applied to the ticket price. */
export const PRIZE_TIERS = [
    { count: 1, multiplier: 100 },
    { count: 16, multiplier: 4 },
    { count: 62, multiplier: 2 },
    { count: 125, multiplier: 1 },
] as const;

/** Extra amount the contract requires on top of the ticket price; it stays on the contract. */
export const BUY_GAS_RESERVE_NANO = 100_000_000n;

/** Share of every regular ticket that goes to the Mega Jackpot fund. */
export const MEGA_FUND_PERCENT = 3;

/** Share of the Mega Jackpot pot (fund + mega ticket sales) paid to the winner. */
export const MEGA_PRIZE_PERCENT = 78;

/** Referral share of a friend's winnings: 1st, 2nd and 3rd referral level. */
export const REFERRAL_WIN_PERCENTS = [10, 5, 2] as const;

/** A referral milestone bonus is paid for every this many invited friends. */
export const REFERRAL_MILESTONE_FRIENDS = 10;

/** Wins in a row (same game level, consecutive cycles) needed for the streak bonus. */
export const WIN_STREAK_LENGTH = 3;

/** Streak bonus, in ticket prices of the level. */
export const WIN_STREAK_BONUS_TICKETS = 2;

/**
 * Referrer's share of a friend's purchase. The contract picks it by the referrer's total of
 * tickets bought by friends, including the purchase itself.
 */
export function soldBonusPercent(ticketsSoldByReferrals: number): number {
    if (ticketsSoldByReferrals > 25) return 10;
    if (ticketsSoldByReferrals > 10) return 5;
    return 3;
}

/** Price multiplier of the player's level (1, 2, 3), used for the referral milestone bonus. */
export function playerLevelK(userLevel: number): number {
    if (userLevel === 3) return 4;
    if (userLevel === 2) return 2;
    return 1;
}

/** Referral milestone bonus in nanoGRAM: basePrice × k(player level) / 5. */
export function referralMilestoneBonusNano(basePriceNano: bigint, userLevel: number): bigint {
    return (basePriceNano * BigInt(playerLevelK(userLevel))) / 5n;
}

/** Win streak bonus in nanoGRAM for a level with the given ticket price. */
export function winStreakBonusNano(ticketPriceNano: bigint): bigint {
    return ticketPriceNano * BigInt(WIN_STREAK_BONUS_TICKETS);
}
